import React from 'react';
import { withStyles } from "@mui/styles";
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Styles} from "../../../../config/design/styles";
import {Alert, AlertTitle} from "@mui/lab";
import Grid from "@mui/material/Grid2";
import SubTitle from "../../../components/elements/SubTitle";
import {getDisplayTime, showExactDate} from "../../../../config/values";
import {Button, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import clsx from "clsx";


function OrdersAlert({alerts, classes,dashboard }) {
    const { t } = useTranslation();

    return (
        <Grid container spacing={1} className={alerts.length > 1 ? clsx(classes.alertBox,"list") : classes.alertBox}>
            {
                alerts.map((alert,index) => (
                    <Grid item size={12}>
                        <Alert
                            key={index}
                            severity={alert.severity}
                            className="flex-direction flex-column-md"
                            action={
                                !!alert.courier &&
                                <Button
                                    variant="outlined"
                                    color="text"
                                    component={Link}
                                    to={`/panel/manage/users/edit/${alert.courier.id}`}
                                >
                                    {alert.courier.first_name}  {alert.courier.last_name}
                                </Button>
                            }
                        >
                            {
                                !!dashboard ?
                                    <AlertTitle><Link color='inherit' to={`/panel/manage/view-order/${alert.order.number}`}>{alert.order.number} - {alert.title}</Link></AlertTitle>
                                    :
                                    <AlertTitle>{alert.title}</AlertTitle>
                            }
                            <Typography align="left">{alert.description}</Typography>
                            <span className="alert-time">{getDisplayTime(alert.created_at)}</span>

                        </Alert>
                    </Grid>
                ))
            }
        </Grid>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(OrdersAlert));
